/**
 * Topal journal import wire shape (POST /api/integrations/topal/import).
 *
 * The RESULT shape is shared with D365 BC / Abacus via `IJournalImportResult`
 * (`./journal-import.model`). Like Abacus, Topal has no fiscal-year discovery endpoint:
 * the FE pulls `fiscalYear*` (and optional `previousFiscalYear*`) from the active Annual
 * Report's General Info, and the BE resolves the Topal fiscalYearId from the date range.
 */
export interface ITopalImportBody {
    companyId: string;
    connectionId: string;
    /** Topal client (Mandant) id, sourced from the connection mapping. */
    externalCompanyId: string;
    /** ISO YYYY-MM-DD. */
    fiscalYearStart: string;
    fiscalYearEnd: string;
    /** Optional YoY pair — both halves or neither (the BE rejects a partial pair). */
    previousFiscalYearStart?: string;
    previousFiscalYearEnd?: string;
}
